import React from 'react';
import Row from './Row';

import trophy from 'resources/images/icons/trophy.png';

class MemoryGameBattleRankingRow extends Row {

  constructor(props){
    super(props);
    this.init(props);
    this.profile = this.func.getById.profileByUser(this.props.data.submittedBy, this.store);
    this.state = {
      filename: this.profile? this.profile.icon: null,
      type: 'profileIcon'
    }
    this.checkUrl();
  }

  UNSAFE_componentWillReceiveProps(newProps){
    this.init(newProps);
    if(newProps.profile && !this.state.filename){
      this.setState({
        filename: newProps.profile.icon,
        type: 'profileIcon'
      })
    }
    this.checkUrl();
  }

  rowInfo(){
    const data = this.props.data;
    const rowStyle = {...this.ui.styles.area, ...{
      width: '100%',
      height: this.bs.height * 0.06,
      alignItems: 'flex-end'
    }}
    const iconSize = this.bs.height * 0.05;
    const textScale = [this.bs.height * 0.05,''];
    const fontSize = this.bs.height * 0.035;
    return(
      <div style={rowStyle}>
        {data.score? this.icon(trophy, [iconSize, iconSize], 0.2): null}
        {data.score? this.textDisplay(data.score, textScale, fontSize, 'center'): null}
      </div>
    )
  }

  render(){
    this.init(this.props);
    if(!this.props.data || !this.profile){ return null; }
    return this.animatedRow(this.content.bind(this), this.bs.height * 0.15)
  }

  content = (style)=>(
      <div style={{...this.rowStyle(), ...{
        height: style.height,
        opacity: style.opacity,
        cursor: ''
      }}}>
        {this.textDisplay((this.props.index + 1) + '.', [this.bs.height * 0.05,''], '200%', 'center', this.props.index === 0? 'gold':this.props.index === 1?'silver': this.props.index === 2? '#CD7F32': 'black')}
        {this.rowIcon()}
        {this.rowContent(this.profile.name, this.rowInfo.bind(this))}
      </div>
  )
}

export default MemoryGameBattleRankingRow;
